import { updateCartCounter } from './DamCartCounter';
import axios from 'axios';
import { DamAssets } from './DamAssets';
import {DamCart} from './DamCart';
import { route } from 'ziggy-js';

export function attachActions() {
    if (document.querySelector('*[data-role=addAllCartAssets]')) {
        document.querySelector('*[data-role=addAllCartAssets]').onclick = async event => {
            const damCart = new DamCart();
            const checked = document.querySelectorAll('*[data-role=tagFilter] input[type=checkbox]:checked');
            let filters = [];

            filters = Array.from(checked).map(x => x.value);
            await axios.get(`${route('dam.add-cart-asset-filtered')}?tags=${filters.join(',')}`, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            await updateCartCounter();

            damCart.init();
        }
    }

    document.querySelectorAll('*[data-role=addCartAsset]').forEach(el => {
        el.onclick = async e => {
            const assetContainer = e.target.closest('*[data-asset-id]');

            await axios.post(route('dam.add-cart-asset', { damAsset: assetContainer.dataset.assetId }), {},{
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            assetContainer.querySelectorAll('.dam-asset-is-in-cart').forEach(el => el.style.display = 'block');
            assetContainer.querySelectorAll('.dam-asset-is-not-in-cart').forEach(el => el.style.display = 'none');

            updateCartCounter();
        }
    });

    document.querySelectorAll('*[data-role=deleteCartAsset]').forEach(el => {
        el.onclick = async e => {
            const assetContainer = e.target.closest('*[data-asset-id]');

            await axios.delete(route('dam.delete-cart-asset', { damAsset: assetContainer.dataset.assetId }), {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            assetContainer.querySelectorAll('.dam-asset-is-in-cart').forEach(el => el.style.display = 'none');
            assetContainer.querySelectorAll('.dam-asset-is-not-in-cart').forEach(el => el.style.display = 'block');

            updateCartCounter();
        }
    });

    if (document.querySelector('*[data-role=clearAllFilters]')) {
        document.querySelector('*[data-role=clearAllFilters]').onclick = e => {
            document.querySelectorAll('*[data-role=tagFilter]').forEach(el => {
                let checkbox = el.querySelector('input[type=checkbox]');

                checkbox.checked = false;
                checkbox.dispatchEvent(new Event('change'));
            });
        };
    }

    if (document.querySelector('*[data-role=changePage]')) {
        document.querySelectorAll('*[data-role=changePage]').forEach(el => {
            el.onclick = e => {
                let pageExists = false;
                const urlSearchParams = new URLSearchParams(window.location.search);

                let url = `${route('dam.index')}?`;
                urlSearchParams.forEach((param, key) => {
                    if (key === 'page') {
                        pageExists = true;
                        param = el.dataset.direction === 'next' ? parseInt(param) + 1 : parseInt(param) - 1;
                    }

                    url += `${key}=${param}&`;
                });

                if (!pageExists) {
                    url += `page=2&`;
                }

                const pageTitle = document.querySelector('h1').innerText;

                window.history.pushState(pageTitle, pageTitle, url.substring(0, url.length - 1));

                const damAssets = new DamAssets();

                damAssets.assets();
            };
        })
    }
}
